//@service
import {bind,RepositoryInterface} from '@/service/utils'
export const researchService= {
  get researchRepository() {
    return bind(() => import('./research.repo'), RepositoryInterface);
  },
  get helpResearchRepository() {
    return bind(() => import('./helpResearch.repo'), RepositoryInterface);
  },
  get researchPlanRepository() {
    return bind(() => import('./researchPlan.repo'), RepositoryInterface);
  },
  get researcherRepository() {
    return bind(() => import('./researcher.repo'), RepositoryInterface);
  },
  get researchManagerRepository() {
    return bind(() => import('./researchManager.repo'), RepositoryInterface);
  },
  get researchAzmoonExecutePersonReferenceRepository() {
    return bind(() => import('./researchAzmoonExecutePersonReference.repo'), RepositoryInterface);
  },


}

